export class HiddenMenu {
    catDetHiddenMenuId: number;
    storeId: number;
    selected: boolean;
    organizationId: string;
}
